

exports.__esModule = true;
exports.$xoAddressDisplayComponent = undefined;

var _index = require('squid/dist/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoAddressDisplayComponent = exports.$xoAddressDisplayComponent = _index.$Component.extend('$xoAddressDisplayComponent', {

    tag: 'xo-address-display',
    template: _template2['default'],

    props: {
        address: {
            type: 'var'
        },
        showPreferred: {
            type: 'str',
            required: false
        },
        countryCode: {
            type: 'str'
        }
    },

    lifecycle: {
        populate: function populate() {
            var address = this.props.address || {};
            this.isPreferred = this.props.showPreferred && address.preferred_address && (0, _index.$feature)('preferredShipping', false, this.props.countryCode);
        }
    }
});

angular.value("$xoAddressDisplayComponent", $xoAddressDisplayComponent);
_index.$Component;

_index.$feature;


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-address-components/src/address-display/directive.js
 ** module id = 308
 ** module chunks = 1
 **/